<img class="img-hgt" src="/assets/banner3.png" alt="iCBMS">
<div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
</div>
<div class="container-fluid image">
    <p class="txt-manage">Convenient, Effective and Secure way to apply and manage your Permits Online
        <br />
        <!--<b (click)="regiser()" class="started">Get started today.</b>-->
        <span *ngIf="environment != 'prod'">
      {{buildVersion}}
    </span>
        <br />
        <br />
        <br />
    </p>

    <div class="card card-move">
        <div class="card-body">
            <h1 class="header" style="margin:0px 0px 4px 0px!important;padding:0px 0px 4px 0px!important;">LOGIN</h1>
            <label>Please complete the fields below to login</label>
            <div class="form-group col-12">
                <input type="text" placeholder="Enter email" [(ngModel)]="loginUser.UserName" class="form-control form-control-sm" #emailref="ngModel" required />
                <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)" class="aler alert-danger">
                    * Email is required
                </div>
            </div>
            <div class="form-group col-12">
                <i class="fa fa-eye-slash" *ngIf="hide==false" id="input_img" (click)="showPassword()" aria-hidden="true"></i>
                <i class="fa fa-eye" *ngIf="loginUser.Password && hide==true" (click)="showPassword()" id="input_img" aria-hidden="true"></i>
                <input [type]="hide ? 'password' : 'text'" placeholder="Enter password" [(ngModel)]="loginUser.Password" class="form-control form-control-sm" #password="ngModel" required />

                <div *ngIf="password.errors &&(password.touched || password.dirty)" class="aler alert-danger">
                    Password is required
                </div>
            </div>
            <div class="col-12" style="height:80px!important;" *ngIf="showCaptcha && environment != 'qa' && environment != 'cbrtauat'  ">
                <re-captcha class="g-recaptcha" data-size="normal" (resolved)="resolved($event)" siteKey="{{getSiteKey()}}">
                </re-captcha>
            </div>
            <div class="col">
                <a class="txt-pass pull-right" (click)="forgot()">Forgot password?</a>
            </div>
            <br />
            <br />
            <div class="btn-align">
                <button class="btn btn-md m-clr hd-btn pull-left" style="height:35px!important;" (click)="login()">Login</button>
                <button class="btn btn-md m-clr hd-btn pull-right" style="height:35px!important;" (click)="regiser()">Register</button>
            </div>
            <br />
            <br />
            <div class="separator">OR</div>
            <br />
            <!-- <span>Or</span> -->
            <!-- <br/>
            <br/>

            <br/>
            <br/> -->
            <!-- <span>OR</span> -->

            <div class="pull-left">
                <button (click)="socialSignIn('facebook')" class="btn btn-md m-clr hd-btn loginBtn loginBtn--facebook btn-facebook">
          <i class="fa fa-facebook mr-1"></i>
          Login with Facebook
        </button>

            </div>
            <!-- <div class="pull-left">
        <button (click)="socialSignIn('azure')"
          class="btn btn-md m-clr hd-btn loginBtn loginBtn--facebook btn-facebook">
          <i class="fa fa-windows mr-1"></i>
          Azure
        </button>
      </div> -->

            <div class="pull-right">
                <div id="buttonDiv"></div>
                <button class="btn btn-md m-clr hd-btn loginBtn loginBtn--google" #loginRef>
          <i class="fa fa-google mr-1"></i>
          Login with Google
        </button>
            </div>
            <br />
            <br />
            <br />
            <div class="col-12" style="text-align:right;margin:0px 0px 4px 0px!important;size: 30px;">
                <span>Please click <a href="https://www.cbrta.co.za/permits/permit-portal"><u>HERE</u></a> to access the
          CrossEasy User Manual &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div class="col-12" style="text-align:left;margin:0px 0px 4px 0px!important;size: 30px;" aria-hidden="true" data-toggle="modal" data-target="#dnnModalLong">
                Login with <a style="color: #000F9F;cursor: pointer;">CBRTA Info Portal <i class="fa fa-info-circle"
            aria-hidden="true"></i></a>
            </div>

        </div>

    </div>

</div>


<div class="modal fade" id="dnnModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <p class="modal-title" id="exampleModalLongTitle">CBRTA Information Portal Login</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-sm">

                <form [formGroup]="dnnForm" class="needs-validation">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Username</label>
                        <input type="text" class="form-control" id="exampleInputEmail1" formControlName="DnnUsername" aria-describedby="emailHelp" placeholder="Enter username" required autocomplete="off">
                        <!-- <div class="valid-feedback">Valid Username.</div> -->
                        <div class="invalid-feedback">Username from CBRTA Info Portal is required.</div>
                        <!-- <small id="emailHelp" class="form-text text-muted">Please use your CBRTA Info Portal Username.</small> -->
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">Password</label>
                        <input type="password" class="form-control" id="exampleInputPassword1" formControlName="DnnPassword" placeholder="Password" required>
                        <!-- <div class="valid-feedback">Valid Password.</div> -->
                        <div class="invalid-feedback">Password from CBRTA Info Portal is required.</div>
                    </div>

                    <button type="submit" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="submit()">Login</button>
                </form>


            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Close</button> -->
                <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
            </div>
        </div>
    </div>
</div>
